import type { FaireProductEntity } from "../../entity_types/product";

export const p_wqrmc65w4t: FaireProductEntity = {
  token: "p_wqrmc65w4t",
  type: "product",
  name: "Aromatherapy Bath Salts \u2013 80ml Tube | Natural |Essential Oil",
  brandName: "Val Viola Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/3ffdd1cf536ce9f81b31726c6109c5219de02d38d66862ff15638c89982c42b8.png",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/40f7e3562c256c68c703be3d5566ec5e6e106d6c6982b9b63a1d580833152a7a.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
